var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 7V11.3333H10.6667V7H9.33337Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13C11 13.5522 10.5523 14 10 14C9.44772 14 9 13.5522 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2727 3.47059C10.7033 2.5098 9.29671 2.5098 8.72736 3.47059L2.45295 14.0588C1.86038 15.0588 2.6213 16.25 3.72561 16.25H16.2744C17.3787 16.25 18.1397 15.0588 17.5471 14.0588L11.2727 3.47059ZM3.78696 14.75L10 4.26529L16.2131 14.75H3.78696Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleS);
export default __webpack_public_path__ + "static/media/alert-triangle-S.a9d6df5b3d48b221b023e03812c8dcee.svg";
export { ForwardRef as ReactComponent };